export const convertFloatToInt = duration => {
  const durationInInteger =
    Number.isInteger(duration) || duration === ""
      ? duration
      : Math.floor(duration);
  return durationInInteger;
};
